const SID = "rl_chat_sid";
const MSGS = "rl_chat_msgs";
const CTA = "rl_chat_cta";

export const pageKey = (path) =>
  path === "/" ? "home" : path === "/candidati-pronti" ? "landing" : path === "/privacy" ? "privacy" : path === "/cookie" ? "cookie" : "404";

export const fonteFor = (key) => (key === "landing" ? "landing_candidati_pronti" : "sito_web");

export function sessionId() {
  let id = sessionStorage.getItem(SID);
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`).replace(/[^a-z0-9-]/gi, "");
    sessionStorage.setItem(SID, id);
  }
  return id;
}

export const loadMsgs = () => {
  try { return JSON.parse(sessionStorage.getItem(MSGS) || "[]"); } catch { return []; }
};
export const saveMsgs = (m) => sessionStorage.setItem(MSGS, JSON.stringify(m.slice(-40)));

export const markChatCta = (key) => sessionStorage.setItem(CTA, JSON.stringify({ sid: sessionId(), fonte_pagina: fonteFor(key) }));

export function chatAttribution() {
  try {
    const c = JSON.parse(sessionStorage.getItem(CTA) || "null");
    return c ? { fonte: "chat", fonte_pagina: c.fonte_pagina, chat_session_id: c.sid } : null;
  } catch {
    return null;
  }
}

export const CTA_MARK = "[[CTA]]";
export const cleanText = (t) => t.replace(/\[\[CTA\]\]/g, "").replace(/\[{1,2}C?T?A?\]?$/, "").replace(/\*\*/g, "").trim();
